import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';

import IconButton from "@material-ui/core/IconButton/index";
import Zoom from "@material-ui/core/Zoom/index";
import Tooltip from "@material-ui/core/Tooltip/index";
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {ReactLocalStorageService} from "../../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {PopupService} from "../../../../../settings/PoPup/PoPup";
import ClienteReceptoraPagoService from "../../../../../services/_Cat/ClienteReceptoraPagoService/ClienteReceptoraPagoService";
import ModalClienteReceptoraPago from "./ModalClienteReceptoraPago";
import {CONFIG} from "../../../../../settings/Config/Config";
import Avatar from "@material-ui/core/Avatar";
import ClienteReceptoraPagoDatoBancario from "../../ClienteReceptoraPagoDatoBancario/ClienteReceptoraPagoDatoBancario";
import {AttachFile, AttachMoney, Business, Description, HomeWork, House, InsertDriveFile, Room} from "@material-ui/icons";
import {DropboxApi} from "../../../../../settings/Dropbox/DropboxApi";
import ModalCIF from "./ModalCIF";
import EmpresaAcrescoSucursal from "../../EmpresaAcrescoSucursal/EmpresaAcrescoSucursal";
import EmpresaAcrescoCertificado from "../../EmpresaAcrescoCertificado/EmpresaAcrescoSucursal";
import ModalDomicilioFiscal from "./ModalDomicilioFiscal";

class ListaTabla extends Component {
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
	}
	
	eliminar = (item) => {
		let msg = `¿Deseas eliminar la empresa receptora de pago ${item.razon_social}?`;
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Eliminar') {
				ClienteReceptoraPagoService.Eliminar(item.id_empresa).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	
	verDocumento = (path) => {
		DropboxApi.Open(path).then(function (data) {
		}).catch(function (error) {
		});
	};
	
	render() {
		
		const {lista} = this.props;
		
		return (
			<Paper style={{overflowX: "auto"}}>
				<Table className={'desing-acresco'}>
					<TableHead>
						<TableRow>
							<TableCell component="th" align={'center'} className={'w-10-px padding-20-L padding-10-R'}>
								ID
							</TableCell>
							<TableCell component="th" align={'center'} className={'padding-30-R'}>Logo</TableCell>
							<TableCell component="th" align={'left'}>Nombre comercial</TableCell>
							<TableCell component="th" align={'left'}>Razón social</TableCell>
							<TableCell component="th" align={'left'}>RFC</TableCell>
							<TableCell component="th" align={'left'}>Correo electronico</TableCell>
							<TableCell component="th" align={'left'}>Telefono</TableCell>
							<TableCell component="th" align={'left'}>Pagina web</TableCell>
							<TableCell component="th" align={'center'}>Activo</TableCell>
							<TableCell component="th" align={'center'}>Comprobante fiscal</TableCell>
							<TableCell component="th" align={'center'}>Domicilios Fiscales</TableCell>
							<TableCell component="th" align={'center'}>CIF</TableCell>
							<TableCell component="th" align={'center'}>Sucursales SAT</TableCell>
							<TableCell component="th" align={'center'}>Datos bancarios</TableCell>
							<TableCell component="th" align={'center'}>Certificados</TableCell>
							<TableCell component="th" align={'center'} className={'w-110-px'}>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{lista.map((item, key) => (
							<TableRow key={key}>
								<TableCell align={'center'} className={'padding-20-L padding-20-R'}>
									{item.id_empresa}
								</TableCell>
								<TableCell align={'left'}>
									<div className={'card-0 b-r-100 w-40-px h-40-px'}>
										<Avatar
											style={{
												width: 40,
												height: 40
											}}
											alt={"Logo"}
											src={item.logo ? CONFIG.src + item.logo:null}
										/>
									</div>
								</TableCell>
								<TableCell align={'left'}>{item.nombre_comercial}</TableCell>
								<TableCell align={'left'}>{item.razon_social}</TableCell>
								<TableCell align={'left'}>{item.rfc}</TableCell>
								<TableCell align={'left'}>{item.correo_electronico}</TableCell>
								<TableCell align={'left'}>{item.telefono}</TableCell>
								<TableCell align={'left'}>{item.pagina_web}</TableCell>
								
								
								{/*<TableCell align={'left'}>{item.acuse ? <Tooltip TransitionComponent={Zoom} placement={"top"} title="Ver Acuse Pago">
									<IconButton aria-label="Ver Acuse Pago" onClick={() => this.verDocumento(item.acuse)}><InsertDriveFile style={{color: 'rgb(142, 30, 50)'}}/></IconButton>
								</Tooltip> : '-'}</TableCell>*/}
								<TableCell align={'center'}>
									{item.activo === 1 ? (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "darkgreen",
											display: "inline-grid",
										}}>Activo</div>
									) : (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "#901C30",
											display: "inline-grid",
										}}>Inactivo</div>
									)}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.archivos_cif.length > 0 ? 'Sí':'No'}
								</TableCell>
								
								<TableCell align={'center'}>
									<ModalDomicilioFiscal
										tipo={'add'}
										item={item}
										componente={(
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Domicilios Fiscales">
												<IconButton aria-label="Domicilios Fiscales"><Room/></IconButton>
											</Tooltip>
										)}
										RefreshList={this.props.RefreshList}
										showSnackBars={this.props.showSnackBars}
									/>
								</TableCell>
								
								<TableCell align={'center'}>
									<ModalCIF
										tipo={'add'}
										item={item}
										componente={(
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Subir CIF">
												<IconButton aria-label="Subir CIF"><Description/></IconButton>
											</Tooltip>
										)}
										RefreshList={this.props.RefreshList}
										showSnackBars={this.props.showSnackBars}
									/>
								</TableCell>
								
								<TableCell align={'center'}>
									<EmpresaAcrescoSucursal
										item={item}
										RefreshList={this.props.RefreshList}
										showSnackBars={this.props.showSnackBars}
									/>
									{/*<ModalSucursalesSAT
										tipo={'add'}
										item={item}
										componente={(
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Sucursales SAT">
												<IconButton aria-label="Sucursales SAT"><Business/></IconButton>
											</Tooltip>
										)}
										RefreshList={this.props.RefreshList}
										showSnackBars={this.props.showSnackBars}
									/>*/}
								</TableCell>
								
								<TableCell align={'center'}>
									<ClienteReceptoraPagoDatoBancario
										item={item}
										RefreshList={this.props.RefreshList}
										showSnackBars={this.props.showSnackBars}
									/>
								</TableCell>
								
								<TableCell align={'center'}>
									<EmpresaAcrescoCertificado
										tipo={'add'}
										item={item}
										RefreshList={this.props.RefreshList}
										showSnackBars={this.props.showSnackBars}
									/>
								</TableCell>
								
								<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
									<div className={'w-auto vertical-inline'}>
										<div className={'v-center'}>
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Eliminar">
												<IconButton aria-label="Eliminar"
												            onClick={() => this.eliminar(item)}>
													<DeleteOutlined/>
												</IconButton>
											</Tooltip>
										</div>
										<div className={'v-center'}>
											<ModalClienteReceptoraPago
												tipo={'edit'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
										<div className={'v-center'}>
											<ModalClienteReceptoraPago
												tipo={'view'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Paper>
		)
	}
}

ListaTabla.propTypes = {
	lista: PropTypes.array.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ListaTabla;
